import React, { useEffect, useState } from 'react'
import { HiOutlineHeart, HiHeart, HiOutlineChatBubbleLeft } from 'react-icons/hi2';
import UserAvatar from '../UserAvatar/UserAvatar';
import { Link } from 'react-router-dom';
import FormatDate from './FormatDate';
import ReplyComment from './ReplyComment';
import axios from '../../Actions/axios.config';
import UserList from '../Popups/UserList';
import { ROUTES } from '../../constants';

const CommentCard = ({ comment }) => {
  const [like, setLike] = useState(false);
  const [count, setCount] = useState(0);
  const [replyCount, setReplyCount] = useState(0);
  const [commentLikes, setCommentLikes] = useState([]);
  const [showCommentLikes, setShowCommentLikes] = useState(false);
  const [replyComment, setReplyComment] = useState(false);

  const handleLikeComment = () => {
    setLike(!like);
    setCount(prev => like ? prev - 1 : prev + 1);
    axios.get(`/comments/like&unlike/${comment._id}`);
  };

  const handleCommentReply = () => {
    setReplyComment(!replyComment);
  };

  const handleShowCommentLikes = () => {
    axios.get(`/comments/getLikes/${comment._id}`)
      .then((response) => {
        setCommentLikes(response.data.Likedby.likes);
        setShowCommentLikes(true);
      })
      .catch(() => {});
  };

  useEffect(() => {
    axios.get(`/comments/getLikes/${comment._id}`)
      .then((response) => {
        setLike(response.data.userLike);
        setCount(response.data.Likedby.likes.length);
      })
      .catch(() => {});

    axios.get(`/comments/getReplies/${comment._id}`)
      .then((response) => {
        setReplyCount(response.data.replies.length);
      })
      .catch(() => {});
  }, [comment._id]);

  return (
    <div className="group mb-6 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <div className="flex gap-3">
        {/* Avatar Section */}
        <Link 
          to={ROUTES.userProfile(comment.user)} 
          className="flex-shrink-0 mt-1 transition-transform active:scale-90"
        >
          <UserAvatar src={comment.userProfileImage} name={comment.userName} size={36} className="ring-1 ring-slate-100 group-hover:ring-blue-200 transition-colors" />
        </Link>

        {/* Content Section */}
        <div className="flex-grow">
          <div className="bg-slate-50 border border-slate-100 p-4 rounded-2xl rounded-tl-none group-hover:bg-white group-hover:shadow-sm transition-all duration-300">
            <div className="flex justify-between items-start mb-1">
              <Link 
                to={ROUTES.userProfile(comment.user)} 
                className="font-black text-slate-900 text-sm hover:text-blue-600 transition-colors"
              >
                {comment.userName}
              </Link>
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                {FormatDate(comment.createdAt)}
              </span>
            </div>
            
            <p className="text-slate-600 text-[15px] leading-relaxed">
              {comment.text}
            </p>
          </div>

          {/* Action Bar */}
          <div className="flex items-center gap-6 mt-2 ml-2">
            <button 
              onClick={handleLikeComment}
              className={`flex items-center gap-1.5 text-xs font-bold transition-colors ${
                like ? 'text-red-500' : 'text-slate-400 hover:text-slate-600'
              }`}
            >
              {like ? <HiHeart size={16} /> : <HiOutlineHeart size={16} />}
              <span>{count > 0 ? count : 'Like'}</span>
            </button>

            <button 
              onClick={handleCommentReply}
              className="flex items-center gap-1.5 text-xs font-bold text-slate-400 hover:text-blue-600 transition-colors"
            >
              <HiOutlineChatBubbleLeft size={16} />
              <span>{replyCount > 0 ? `${replyCount} Replies` : 'Reply'}</span>
            </button>

            {count > 0 && (
              <button 
                onClick={handleShowCommentLikes}
                className="text-[10px] font-black text-slate-300 uppercase tracking-tighter hover:text-slate-500 transition-colors"
              >
                View Likers
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Nested Replies Rendering */}
      {replyComment && (
        <div className="ml-12 mt-4 border-l-2 border-slate-100 pl-4">
          <ReplyComment 
            comment={comment} 
            handleCommentReply={handleCommentReply}
          />
        </div>
      )}

      {showCommentLikes && (
        <UserList 
          likers={commentLikes} 
          onClose={() => setShowCommentLikes(false)}
        />
      )}
    </div>
  );
}

export default CommentCard;